<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_3"><span class="txbf">DEDICATION</span></a></p><a id="page_3">
<hr class="hr1"/>
</a><p class="ded1"><a id="page_3">To my mother, who taught me the importance of good thoughts, good words, and good deeds.</a><a id="page_4"></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?394fdb21